import { render, staticRenderFns } from "./addIpBlack.vue?vue&type=template&id=6dcc723e&scoped=true&"
import script from "./addIpBlack.vue?vue&type=script&lang=js&"
export * from "./addIpBlack.vue?vue&type=script&lang=js&"
import style0 from "./addIpBlack.vue?vue&type=style&index=0&id=6dcc723e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dcc723e",
  null
  
)

export default component.exports